import { useState } from "react";

export default function Cards({
  title,
  Icon,
  number,
  img,
  iconType = "img",
  color
}) {
  return (
    <div className="">
      <div
        className="px-3 m-2 "
        style={{
          borderRadius: 20,
          minWidth: 220,
          minHeight: 220,
          maxWidth: 260,
          maxHeight: 240,
          backgroundColor: color
        }}
      >
        {/* {loadImg ? (
          <div
            style={{
              maxWidth: 260,
              maxHeight: 240,
              backgroundColor: "azure"
            }}
          ></div>
        ) : ( */}
        {/* <img
          src={img}
          // onLoad={() => setLoadImg(false)}
          style={{
            maxWidth: 260,
            maxHeight: 240
          }}
        /> */}
        {/* )} */}
        {/* <div > */}
        <h5 className="text-white fs-6 pt-5">{title}</h5>
        {iconType == "icon" && (
          <div className="d-flex justify-content-end mt-5">{Icon}</div>
        )}
        {iconType == "img" && (
          <div className="d-flex justify-content-end mx-2">
            <div
              className="d-flex justify-content-center mt-4 text-end"
              style={{
                width: 80,
                height: 70,
                backgroundColor: "white",
                borderRadius: "10px",

                overflow: "hidden"
              }}
            >
              <img
                src={Icon}
                width="60px"
                height="50px"
                // style={{ overflow: "hidden" }}
              />
            </div>
          </div>
        )}
        <h6 className="text-end text-white fs-5 mt-3 mx-4">{number}</h6>
        {/* </div> */}
      </div>
    </div>
  );
}
